module.exports = __webpack_public_path__ + "static/media/S (202).1de46298.jpg";